<template>
    <div class="container">
        <div class="pageContent">
            <ActionCard :data="params.company" v-if="$mqBelow('DESKTOP')">
                <template #footer>
                    <div class="flex between borderedCard" v-if="params.company.items">
                        <div v-for="item in params.company.items">{{item}}
                          <span>{{item.title}}</span>
                          <span>{{item.desc}}</span>
                        </div>
                    </div>
                </template>
            </ActionCard>
            <main class="pt-4">
                <form :name="'requestSubmit'"
                      :action="form.action"
                      :method="form.method"
                      class="stepper-form"
                      @submit.prevent="formSend($event)">
                  <div class="row">
                    <template  v-for="(field,index) in form.fields">
                        <input type="hidden" :name="field.name" :value="field.value" v-if="field.type=='hidden'">
                        <div v-else class="col sm-12" :data-index="index" :class="'d-'+field.greedLang+' '+field.class">

                        <h3 v-if="field.type=='subtitle'" v-html="field.title"></h3>
                        <AInput v-else-if="field.type=='text'||field.type=='textarea'||field.type=='file'"
                                static-label
                                :hint="field.maxLength?textLimitHint(field.value,field.maxLength):field.hint"
                                :type="field.type"
                                :placeholder="field.placeholder"
                                :label="field.title"
                                :name="field.name"
                                :error="field.error"
                                v-model="field.value"
                        >
                            <template #append v-if="field.type=='file'&&field.value">
                                <span class="a-field-file-clear" @click="field.value=''"></span>
                            </template>
                        </AInput>
                        <ASelect v-else-if="field.type=='select'"
                                 static-label
                                 :label="field.title"
                                 :name="field.name"
                                 @change="setUrlOnChangeDirection(field)"
                                 display="name"
                                 :placeholder="field.placeholder"
                                 :options="field.options"
                                 :error="field.error"
                                 v-model="field.value"
                        >
                          <template #item="{name}">{{ name }}</template>
                        </ASelect>
                        <ADatePicker v-else-if="field.type=='date'"
                                     static-label
                                     :label="field.title"
                                     :placeholder="field.placeholder"
                                     :name="field.name"
                                     :error="field.error"
                                     v-model="field.value"
                        />
                        <div class="field static-label"  v-else-if="field.type=='level'">
                          <label class="label">{{field.title}}</label>
                          <div class="projectLevel__badges">
                            <ABadge v-for="(level, key) in field.count"
                                    :key="key"
                                    :alt="field.value == level"
                                    :error="field.error"
                                    @click.native="field.value=level"
                            >
                              {{ level }}
                            </ABadge>
                          </div>
                        </div>
                        <ACheckbox v-else-if="field.type=='checkbox'" v-model="field.value" :label="field.title" :error="field.error"/>
                        <div v-else-if="field.type=='bonuses'">

                          <ASelect
                                   static-label
                                   :label="field.title"
                                   :name="field.name"
                                   :multiple="field.multiple"
                                   display="title"
                                   :placeholder="field.placeholder"
                                   :options="field.options"
                                   v-model="field.value"
                          >
                            <template #item="item">
                              <div class="flex v-center">
                                <a-checkbox :label="item.title" v-model="item.selected"/>
                              </div>
                            </template>
                          </ASelect>

                          <div v-if="field.value.find((element) => {return element.value==='else';})?.value">
                              <AInput
                                    static-label
                                    :hint="field.maxLength?textLimitHint(field.value,field.maxLength):field.hint"
                                    type="text"
                                    :placeholder="field.placeholder"
                                    :label="field.title"
                                    :name="field.name"
                                    v-model="field.value.find((element) => {return element.value==='else';}).title"
                            />
                          </div>
                        </div>
                        <pre v-else>
                          {{field}}
                        </pre>

                      </div>
                    </template>


                    <div class="col d-6 sm-12">
                        <ABtn :label="params.messages.saveBtn" :class="'primary w-100 mb-3'" type="submit" />
                    </div>
                    <div class="col d-6 sm-12">
                        <ABtn :label="params.messages.cancelBtn" :href="form.cancelLink" :class="'primary w-100 outlined cancelBtn mb-3'" bg="#fff" color="var(--c-primary-200)"/>
                    </div>
                  </div>
                </form>
            </main>
            <div>
                <aside>
                <ActionCard :data="params.company" v-if="$mqAbove('TABLET')">
                    <template #footer>
                        <div class="flex between borderedCard" v-if="params.company.items">
                            <div v-for="item in params.company.items">
                                <span>{{item.title}}</span>
                                <span>{{item.desc}}</span>
                            </div>
                        </div>
                    </template>
                </ActionCard>
                <AccordionCard v-if="params.info" :data="params.info"/>
            </aside>
            </div>
        </div>
      <TaskOnModeration></TaskOnModeration>
    </div>
</template>

<script>
import {
    ref, computed
} from 'vue'
import {useHeader} from "~/composables/useHeader";
import {AChip, ABtn, AInput, ASelect, ADatePicker, ACheckbox, ABadge, useAProgressBar, useAModal} from '~/components/ui'
import ActionCard from "~/components/cards/ActionCard";
import {validateFormItem} from "~/libs/Validators";
import {send} from "~/services/api";
import AccordionCard from "../../components/cards/AccordionCard";
import TaskOnModeration from "../../components/popups/TaskOnModeration";

export default {
    name: "RequestCreatePageContainer",
    props: {
        params: {
            type: Object,
            default: {}
        }
    },
    components: {
        AccordionCard,
        ActionCard,
        AChip,
        AInput,
        ABtn,
        ASelect,
        ADatePicker,
        ACheckbox,
        ABadge,
        TaskOnModeration
    },
    setup(props) {
        const {subHeader} = useHeader()
        const form = ref(props.params.form);
        const activeTab = ref(0)
        const selectedDifficultyLevel = ref(0)
        const hoveredDifficultyLevel = ref(null)
        const modal = useAModal()
        const fieldData = ref({
            notifications: true
        })

        const difficultyLevels = computed(() => {
            return [1, 2, 3, 4]
        })

        const onClick = () => {
            console.log('ONCLICK')
        }
      const progress = useAProgressBar();
        const formSend = async (e) => {
          let formData = new FormData();
          let hasError = false;
          let firstError = -1;
          for (let fieldIndex in form.value.fields) {
            if(typeof form.value.fields[fieldIndex]=="object") {
              let r = validateFormItem(form.value.fields[fieldIndex]);
              if(r.valid) {
                form.value.fields[fieldIndex].error=false;
                for (let fI in r.value) {
                  if(typeof r.value[fI]=="object") {
                    formData.append(r.value[fI].name, r.value[fI].value);
                  }
                }
              } else {
                form.value.fields[fieldIndex].error=true;
                hasError = true;
                if(firstError===-1) {
                  firstError = fieldIndex;
                }

              }

            }
          }
          if(!hasError) {
            // progress.show();
            await send(props.params.form.action, {method: props.params.form.method}, formData).then((response) => {
              if(response[props.params.responseKey].error) {
                // showNotification("danger", "", response[props.params.responseKey].error);
                // progress.hide();
              } else if(response[props.params.responseKey].saved.link) {
                showNotification("success", "", "Создание заявки...", null, 5000);
                setTimeout(()=>{
                  modal.show('task-on-moderation')
                  // location.href=response[props.params.responseKey].saved.link;
                },5000);
              }
            })


          } else {

            if (firstError!==-1) {
              console.log(firstError);
              var destination = document.querySelector('[data-index="' + firstError + '"]');
              console.log(destination)
              destination.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          }
        }

        const selectDifficultyLevel = (key) => {
            selectedDifficultyLevel.value = difficultyLevels.value[key]
        }

        const difficultyBadgeIsHovered = key => {
            return hoveredDifficultyLevel.value === key
        }

        /**
         * Подсказка сколько символов осталось ввести если есть ограничение
         * @todo make it global
         * @param type String - ключ из v-model поля
         * @param limit Number - ограничение по символам
         */
        const textLimitHint = (type, limit = 500) => {
            if (!type || typeof type !== 'string')
                return `0/${limit}`;

            return `${type.length}/${limit}`
        }
        const setUrlOnChangeDirection = (v) =>{
          if(v.name =='PROP[NAPRAVLENIY]') {
            let url = new URL(window.location.href);
            url.searchParams.set('direction',v.value);
            history.pushState(null, null, url.toString());
          }

        }

        return {
            fieldData,
            subHeader,
            activeTab,
            form,
            selectedDifficultyLevel,
            setUrlOnChangeDirection,
            difficultyLevels,
            onClick,
            textLimitHint,
            selectDifficultyLevel,
            hoveredDifficultyLevel,
            difficultyBadgeIsHovered,
            formSend
        }
    },
}
</script>

<style scoped lang="scss">
.a-btn {

  margin-top: 20px;

}
.stepper-form .row {
  h3 {
    margin-top: 1.5rem;
  }
}
.stepper-form .row .col:first-child {
  h3 {
    margin-top: 0;
  }
}

aside {
    position: sticky;
    top: calc(rem(150) + rem(100));
    transform: translateY(rem(-150));

    @include tablet {
        display: none;
    }
}

::v-deep .ActionCard {
    margin-bottom: 45px;

    &__footer {
        @include tablet {
            display: none;
        }
    }

    @include tabletOnly {
        position: absolute;
        right: rem(-15);
        top: rem(-240);
        transform: unset;
        box-shadow: unset;
        max-height: 250px;
    }

    @include mobile {
        position: static;
        top: rem(50);
        transform: translateY(rem(-50));
        margin-bottom: rem(-50);
    }
}

.tabsContainer {
    @extend %contentLayout;
}

.projectLevel {
    &__badges {
        display: flex;
        gap: rem(18);
    }
}

::v-deep .a-badge-inner {
    min-width: rem(68);
    font-weight: 600;
    font-size: rem(14);
    line-height: rem(19);
    color: #000;
    cursor: pointer;
    text-align: center;
}

::v-deep .cancelBtn:hover .a-btn-title {
    color: #fff;
}
</style>